import React from "react";
import { observer } from "mobx-react";
import quizStore from "../stores/quizStore";

const Login = observer(() => {
  const { userInfo, errors, areas, charges } = quizStore;
  const onchange = ({ target }) =>
    quizStore.setUserInfo(target.name, target.value);
  const submit = () => quizStore.register();
  return (
    <div className="row">
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div className="col-12">
          <h3>¡Hola!</h3>
          <p>Seguimos desarrollando nuestra <span style={{fontWeight: "bold"}}>#ActitudEmergente!</span><br />
            Para ello te invitamos a desafiarte y poner tus competencias en juego en esta trivia de preguntas donde encontrarás distintos escenarios relacionados con el mundo laboral y la vida cotidiana.
          </p>
          <br />
          <p> Descripción del desafío: </p>
          <ul>
            <li>Encontrarás 16 casos con escenarios de negocio y de la vida cotidiana:</li>
            <li>Deberás elegir una alternativa de respuesta para cada uno de ellos dentro de las opciones que te ofrece el juego.</li>
            <li>Te aclaramos que en esta instancia no hay respuestas correctas ni incorrectas, buenas ni malas, ya que cada uno piensa y acciona en función de su forma de ser, de sus preferencias e intereses.</li>
            <li>Es muy importante que respondas de manera espontánea y sincera.</li>
            <li>Una vez que respondas no podrás volver hacia atrás</li>
          </ul>

          <br />
          <p> Observaciones importantes: </p>
          <ul>
            <li>El juego te llevará aproximadamente 15 minutos.</li>
            <li>No permite guardar y continuar luego. Una vez que comiences, debes finalizarlo.</li>
          </ul>

          <h2>¡Muchas gracias por sumarte a esta experiencia!</h2>
        </div>
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        { /* No agrega margen / padding en mobile <div className="row mb-3 logo"> */ }
          <div className="col-12 mt-3 d-flex justify-content-center">
            <h3>Ingresa tus datos para completar el cuestionario</h3>
          </div>
        { /* </div> */ }
        <form className="border-top pt-4">
          <div className="mb-3 col-12">
            <label htmlFor="name" className="form-label">
              Nombre y Apellido
            </label>
            <input
                type="text"
                className="form-control"
                id="name"
                value={userInfo.name}
                name="name"
                onChange={onchange}
            />
            {errors.name && (
                <p className="error">Por favor, completá tu Nombre y Apellido.</p>
            )}
          </div>

          <div className="mb-3 col-12">
            <label htmlFor="mail" className="form-label">
              Correo Electrónico
            </label>
            <input
                type="email"
                className="form-control"
                id="mail"
                value={userInfo.mail}
                name="mail"
                onChange={onchange}
            />
            {errors.mail && (
                <p className="error">Por favor, completá tu dirección de e-mail.</p>
            )}
          </div>

          <div className="mb-3 col-12">
            <label htmlFor="doc" className="form-label">
              Documento Nacional de Identidad
            </label>
            <input
                type="dni"
                className="form-control"
                id="doc"
                value={userInfo.doc}
                name="doc"
                onChange={onchange}
            />
            {errors.doc && (
                <p className="error">
                  Por favor, completá tu documento, sin puntos ni espacios.
                </p>
            )}
          </div>

          <div className="mb-3 col-12">
            <label htmlFor="inputArea" className="form-label">
          {/*<div className="row">
            <div className="mb-3 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label htmlFor="inputArea" className="form-label col-6 px-0">*/}
                Área de trabajo
              </label>
              <select
                  className="form-select"
                  id="inputArea"
                  aria-label="Seleccioná el área de tu trabajo"
                  name="area"
                  onChange={onchange}
                  value={userInfo.area}
              >
                <option key={""} value="" className="selected">
                  Selecciona un área de esta lista...
                </option>
                {areas.map((a) => (
                    <option key={a.name} value={a.name}>
                      {a.name}
                    </option>
                ))}
              </select>
              {errors.area && (
                  <p className="error">Por favor, seleccioná tu área de trabajo.</p>
              )}
            {/*</div>*/}

			{/*
            <div className="mb-3 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label htmlFor="inputArea" className="form-label col-6 px-0">
                Cargo
              </label>
              <select
                  className="form-select"
                  id="inputArea"
                  aria-label="Seleccioná tu cargo"
                  name="charge"
                  onChange={onchange}
                  value={userInfo.charge}
              >
                <option key={""} value="" className="selected">
                  Selecciona un cargo de esta lista...
                </option>
                {charges.map((a) => (
                    <option key={a.name} value={a.name}>
                      {a.name}
                    </option>
                ))}
              </select>
              {errors.charge && (
                  <p className="error">Por favor, seleccioná tu área de trabajo.</p>
              )}
          </div>
		  */}
          </div>

		
          <div className="mb-3 col-12">
          <button type="button" className="btn mt-3" onClick={submit}>
            COMENZAR
          </button>
		  </div>
        </form>
      </div>
    </div>
  );
});
export default Login;

